import React from "react"
import { Col, Row } from "react-bootstrap"
import { HeaderProps } from "../types/header"


export const Header = (props: HeaderProps) => {

    return (
        <Row>
            <Col>
                <Row>
                    <Col xs={props.children ? 8 : 12}>
                        <h2 className={`m-0 custom-lead text-${props.xPosition ?? "left"} text-${props.color ?? "black"}`}>
                            {props.title}
                        </h2>
                    </Col>
                    {props.children &&
                        <Col xs={4} className="text-align-right">
                            {props.children}
                        </Col>
                    }
                </Row>
            </Col>
        </Row>
    )
}




// WEBPACK FOOTER //
// ./src/common/headers/Header.tsx